<template>
    <div>
        <vx-card class="">
            <div class="vx-row w-full mb-6" v-show="name">
                <div class="vx-col w-full"
                     style="padding: 0rem 0rem 0rem 1rem;">
                    <span class="text-base font-medium ">
                        {{ $t("title") }}
                    </span><br>
                    <span>{{ name }}</span>
                    <span
                        class="text-danger text-sm"
                        v-show="errors.has('title')">
                        {{ $t('validation_required') }}
                    </span>
                </div>
            </div>
            <div class="vx-row w-full " v-show="text">
                <div
                    class="vx-col w-full"
                    style="padding: 0rem 0rem 0rem 1rem;">
                    <span class="text-base font-medium ">
                        {{ $t("description") }}
                    </span>
                    <div style="margin-top: 10px;">
                        <span v-html="text"></span>
                    </div>

                </div>
            </div>

            <div style="padding: 20px 0px 40px;" v-show="file_path">
                <span class="text-base font-medium ">
                    {{ $t("upload_the_required_documents") }}
                </span>
                <div style="bottom: 10px;left:20px ; position: absolute;">

                    <vs-button
                        style=""
                        class="edit_achievement_btn edt_btn lg:mr-3 "
                        color="primary"
                        icon-pack="feather"
                        icon="icon-save"
                        download
                        :href="file_path"
                        target="_window"
                        type="filled">
                        {{$t('down_file')}}
                    </vs-button>
                </div>
            </div>

        </vx-card>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
    data () {
        return {
            toolbar: '#toolbar',
            data:[],
            text:'',
            name:'',
            files:[],
            modal:false,
            let_files:null,
            file_path:null
        }
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    components: {
        quillEditor,
    },
    watch:{
        item(){
            this.modalUpdate()
        }
    },
    created() {
        this.modalUpdate()
    },
    methods: {
        async modalUpdate(){
            this.files = null
            await this.$http.get('/common/reference_guide/'+this.item.uid).then((res) => {
                this.data = res.data;
                this.file_path = this.data.file.path
                this.text = this.data.description
                this.name = this.data.name

            });
        },
        successUpload(){
            this.$vs.notify({color:'success',title:'Upload Success',text:'Lorem ipsum dolor sit amet, consectetur'})
        },
        setImageGalery(response) {
            this.uploadImages = []
            response.forEach((item) => {
                this.uploadImages=item.uid
            });
        },
        async removeFileGalery({ file, done }) {
            this.files = await this.files.filter(
                (item) => {item.uid !== file.uid}
            );
            done();
        },
        async updateImageGalery() {
            this.$vs.loading();
            if (this.uploadImages == undefined){
                this.uploadImages = ""
            }
            const res = await this.$http.put(
                `/common/reference_guide/`+this.data.uid+`/`,
                {description:this.text, file: this.uploadImages,name:this.name}
            );
            if (res.status === 200) {
                this.galeryImages = res.data.gallery_files;
                this.$vs.notify({
                    title: this.$t("succesful"),
                    color: "primary",
                });
                this.trueUpload = false;
                setTimeout(() => {
                    this.trueUpload = true;
                }, 300);
                this.activeAddGalery = false;
                this.$emit("modalChanged",this.modal);
            }
            this.$vs.loading.close();
        },
    },
    computed: {}
}
</script>

<style lang="scss">
.bug_complete,
.take_to_work{
    position: relative;
    .con-vs-loading{
        position: absolute;
        background: transparent;
    }
}
</style>

<style lang="scss" scoped>
.file_bugs_item{
    &:not(:last-child){
        margin-bottom: 10px;
    }
    img{
        max-width: 100%;
        border: 1px solid #cccccc;
    }
}
</style>
